<div class="col-12">

  <div class="bs-callout bs-callout-info">
    <h5 class="titulo-bloco"> Contrato </h5>
    <hr />

    <form (ngSubmit)="save()" novalidate>
      <label>Nº Contrato: <b>{{contrato?.numContrato}}</b></label>

      <hr />
      <div class="clearfix">
        <button type="button" class="btn btn-sm btn-primary" [routerLink]="['/contratos']"
          routerLinkActive="router-link-active"> Voltar </button>
        <button type="submit" class="btn btn-sm btn-success float-end" [ladda]='running'> Gravar </button>
      </div>
    </form>

  </div>
</div>
